import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './styles/main.css'
import { i18n } from './i18n'

import { useAuthStore } from './stores/useAuthStore'
import { useOfflineStore } from './stores/useOfflineStore'
import { seedDefaultAdmin } from './seed/seedDefaultAdmin'
import { setupPouchDBDevTools } from './utils/pouchdb-dev-tools'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(i18n)

const authStore = useAuthStore()
const offlineStore = useOfflineStore()

// Seed and auth init must complete BEFORE the router is installed so that
// navigation guards see the correct isAuthenticated state on the first load.
await seedDefaultAdmin().catch((err) =>
  console.warn('[Seed] No se pudo crear el admin por defecto:', err)
)
await authStore.initializeAuth()

// Router installed after auth is ready — guards see correct state immediately.
app.use(router)
app.mount('#app')

offlineStore.updateOnlineStatus(navigator.onLine)
window.addEventListener('online', () => offlineStore.updateOnlineStatus(true))
window.addEventListener('offline', () => offlineStore.updateOnlineStatus(false))

// Dev tools for debugging PouchDB in dev mode
setupPouchDBDevTools()
